export default __webpack_public_path__ + "static/media/Media2.2dcd0032.png";